import * as React from "react";
import {Typography, withStyles} from "@material-ui/core";
import {CheckboxButtonStyle} from "@components/common/checkboxButton/checkboxButton.style";
import {Check} from "@material-ui/icons";
import clsx from "clsx";

interface ICheckboxButtonProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label: React.ReactNode;
    classes: any;
    error?: string | undefined;
}

interface ICheckboxButtonState {
    isFocused: boolean;
}

class CheckboxButton extends React.Component<ICheckboxButtonProps, ICheckboxButtonState> {
    private checkboxRef: React.RefObject<HTMLInputElement>;

    constructor(props: ICheckboxButtonProps) {
        super(props);
        this.checkboxRef = React.createRef();

        this.state = {
            isFocused: false,
        };

        this.handleCheckboxBlur = this.handleCheckboxBlur.bind(this);
        this.handleCheckboxFocus = this.handleCheckboxFocus.bind(this);
    }

    public render() {
        const {isFocused} = this.state;
        const {id, key, label, classes, error, ...rest} = this.props;
        const checkboxClassName = [];

        if (this.props.checked) {
            checkboxClassName.push(classes.checkedCheckbox);
        }
        if (error) {
            checkboxClassName.push(classes.invalidCheckbox);
        }
        if(isFocused) {
            checkboxClassName.push(classes.focusedCheckbox);
        }

        return (
            <label
                htmlFor={id}
                key={key}
                className={clsx([classes.root, ...checkboxClassName])}
            >
                <Typography className={classes.label}>{label}</Typography>
                <input
                    {...rest}
                    ref={this.checkboxRef}
                    id={id}
                    className={classes.checkbox}
                    type="checkbox"
                    onBlur={this.handleCheckboxBlur}
                    onFocus={this.handleCheckboxFocus}
                />
                {this.props.checked && <Check color="inherit" fontSize="small" />}
            </label>
        );
    }

    private handleCheckboxBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: false,
        });
        const checkboxElement = this.checkboxRef.current;
        if (checkboxElement) {
            checkboxElement.reportValidity(); // Trigger HTML checkbox validity check
        }

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    }

    private handleCheckboxFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: true,
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }
}

export default withStyles(CheckboxButtonStyle)(CheckboxButton);



// WEBPACK FOOTER //
// ./src/components/common/checkboxButton/checkboxButton.component.tsx